import CardConsolidationResult from './CardConsolidationResult';

export default (props) => {
  return <CardConsolidationResult {...props} />;
};
